var _ellipse, _mask, _g, _mask2, _g2, _ellipse2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 66,
    viewBox: "0 0 60 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 30.0882,
    rx: 30,
    ry: 30.0882,
    fill: "#00325B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 61
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 30.0882,
    rx: 30,
    ry: 30.0882,
    fill: "#FFC145"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 61
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 30.0882,
    rx: 30,
    ry: 30.0882,
    fill: "#FFC145"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5401 63.761V57.6146C48.5401 54.3544 47.5634 51.2277 45.825 48.9224C44.0866 46.617 41.7288 45.3219 39.2703 45.3219H20.7307C18.2722 45.3219 15.9144 46.617 14.176 48.9224C12.4376 51.2277 11.4609 54.3544 11.4609 57.6146V63.761",
    fill: "#E61855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0003 36.0234C35.1198 36.0234 39.27 31.861 39.27 26.7264C39.27 21.5918 35.1198 17.4293 30.0003 17.4293C24.8807 17.4293 20.7305 21.5918 20.7305 26.7264C20.7305 31.861 24.8807 36.0234 30.0003 36.0234Z",
    fill: "white"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.318,
    cy: 56.2941,
    rx: 9.67742,
    ry: 9.70588,
    fill: "#0362AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5493 55.7104V56.8654H47.0977V55.7104H53.5493ZM49.7465 53.0591H50.9004V59.5297H49.7465V53.0591Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.09d516f8011ff89c9a4c3972c17e4b86.svg";
export { ForwardRef as ReactComponent };